export default __webpack_public_path__ + "static/component-overview-find-id-b12a0e333b28268c95458d980f0712d5.png";